import React, { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Link } from "react-router-dom";
import { createEmptyCart } from "../../actions";
import { isTap2Buy, isGiftGuru } from "../../helper/common";
import { useCategories } from "../../hooks/useAmplifyData";

const BrowsePage = () => {
  const dispatch = useDispatch();
  const auth = useSelector(state => state.auth);

  // Fetch categories from Amplify
  const { data: categories, isLoading, error } = useCategories({ activeOnly: true, menuOnly: true });

  // Debug logging
  console.log('BrowsePage Debug:', {
    isLoading,
    error,
    categories,
    categoryCount: categories?.length
  });

  useEffect(() => {
    if (auth.is_signed_in) {
      dispatch(createEmptyCart());
    }
  }, [auth.is_signed_in, dispatch]);

  // Filter to only show top-level categories (level 1 or parent_id = 0)
  const topLevelCategories = (categories || []).filter(
    cat => cat.level === 1 || cat.parent_id === 0 || !cat.parent_id
  );

  if (error) {
    return (
      <div id="page-browse">
        <h1 className="h1">Error</h1>
        <div className="explanatory-text">Failed to load categories. Please try again.</div>
        <div style={{ color: 'red', marginTop: '10px' }}>{String(error)}</div>
      </div>
    );
  }

  return (
    <div id="page-browse">
      <h1 className="h1">
        {isTap2Buy() ? 'Browse Products' : isGiftGuru() ? 'Browse Gift Cards' : 'Browse Products'}
      </h1>
      <div className="explanatory-text">
        Select a category to start shopping
      </div>

      {isLoading ? (
        <div style={{ textAlign: 'center', padding: '40px' }}>Loading categories...</div>
      ) : (
        <div className="category-grid">
          {topLevelCategories.length === 0 ? (
            <div style={{ textAlign: 'center', padding: '40px', color: '#666' }}>
              No categories found
            </div>
          ) : (
            topLevelCategories.map(category => (
              <Link
                to={`/category/${category.category_id}`}
                key={category.category_id}
                className="category-tile"
              >
                <div className="category-image">
                  {category.image_url ? (
                    <img src={category.image_url} alt={category.name} />
                  ) : (
                    <div className="category-placeholder">
                      {category.name.charAt(0)}
                    </div>
                  )}
                </div>
                <div className="category-name">{category.name}</div>
                {category.description && (
                  <div className="category-description">{category.description}</div>
                )}
              </Link>
            ))
          )}
        </div>
      )}
    </div>
  );
};

export default BrowsePage;
